import Path from "@core/FileProvider/Path/Path";
import type ApiUrlCreator from "@core-ui/ApiServices/ApiUrlCreator";
import { getNoParentResource } from "@core-ui/ContextServices/ResourceService/utils/utils";
import { LinkAdapter } from "@ext/agent/mcp/parser/adapters/linkAdapter";

export const loadAgentFile = async (
	href: string,
	apiUrlCreator: ApiUrlCreator,
	signal?: AbortSignal,
): Promise<{ buffer: Buffer; path: Path } | null> => {
	const workspacePath = LinkAdapter.fromAgentFileHref(href);
	if (!workspacePath) return null;

	const catalogName = new Path(workspacePath).rootDirectory.removeExtraSymbols.value;
	const catalogRelativePath = workspacePath.slice(catalogName.length + 1);
	const result = await getNoParentResource(
		new Path(catalogRelativePath),
		apiUrlCreator.fromNewArticlePath("", catalogName),
		signal,
	);
	if (!result.buffer?.byteLength) return null;
	return { buffer: result.buffer, path: new Path(workspacePath) };
};
